import { OneTrustConsent } from './types';

export const consentDisabled: OneTrustConsent = {
    doNotTrack: false,
    limitAdvertisementTracking: false,
    tcfConsentString: null,
};

export const consentNotReady: OneTrustConsent = {
    doNotTrack: null,
    limitAdvertisementTracking: null,
    tcfConsentString: null,
};
